import { ClientSurveyLink } from "app/AppRouter/links"
import { PersonalInfoText } from "components/PersonalInfoText"
import { Button } from "ui-kit/components-branded/index"

export function ActionButtons(props: {
    showPersonalInfo: boolean
    disabled?: boolean
    actionButtonLabel?: string
    onClick?: () => void
}) {
    return (
        <div>
            {props.actionButtonLabel && (
                <Button
                    isFullwidth
                    color="primary"
                    className="mgv-3"
                    onClick={props.onClick}
                    isLoading={props.disabled}
                    type="submit"
                >
                    {props.actionButtonLabel}
                </Button>
            )}
            {props.showPersonalInfo && props.actionButtonLabel ? (
                <PersonalInfoText text={props.actionButtonLabel} />
            ) : (
                <ClientSurveyLink className="border-radius-5 py-3 px-5 text-center b-button button--regular w-100 survey-results-card__more-details-button transition-ease">
                    Подобрать психолога
                </ClientSurveyLink>
            )}
        </div>
    )
}
